module.exports = __webpack_public_path__ + "img/DC-star.e99025b0.svg";